import Vue from 'vue'
import { Toast } from 'vant'
import utils from '../utils'
Toast.allowMultiple()
Vue.use(Toast)
Vue.use(utils)
const getBrowser = function () {
  const userAgent = window.navigator.userAgent
  if (/MicroMessenger/.test(userAgent)) {
    return 'weixin'
  } else if (/AlipayClient/.test(userAgent)) {
    return 'alipay'
  } else {
    return 'other'
  }
}

// const defaultLoading = {
//   loading: undefined,
//   count: 0,
//   create () {
//     if (this.count === 0) {
// this.loading = Toast.loading({
//   message: '加载中...',
//   forbidClick: true,
//   loadingType: 'spinner',
//   duration: 10000
// })
//     }
//     this.count++
//     return () => {
//       if (--this.count <= 0) {
//         this.loading.clear()
//       }
//     }
//   }
// }

// 对 service 进行处理，并且当 401 发生当时候，跳转到登录页
function createProxy (service, loading, obj) {
  const $service = {}
  // loading = loading || defaultLoading
  Object.keys(service).forEach((key) => {
    if (typeof service[key] === 'function') {
      $service[key] = async (args, message) => {
        // const closeLoading = loading.create()
        return service[key](args)
          .then((result) => {
            // closeLoading()
            if (message) {
              Toast({
                type: 'success',
                message: '操作成功'
              })
            }
            return result
          })
          .catch((error) => {
            const data = error.data
            // closeLoading()
            // code 为20002 都是用户登录不成功，token失效
            if (data.code === 20002) {
              localStorage.setItem('accessTokenInfo', null)
              // obj.$constants.onLogin(
              //   'account,weixin,qq,phoneDynameic',
              //   window.location.href
              // )
              return false
            }
            if (data.code === 400102) {
              const loginUrl = process.env.VUE_APP_TITLE === 'production' ? window.location.origin : 'https://beta-mall.coocaa.com'
              const loginMethod = getBrowser() === 'alipay'
                ? 'theme=coocaa-pay-login&loginMethod=phoneDynameic'
                : 'theme=coocaa-added-service&loginMethod=weixin,qq,phoneDynameic'
              window.location = `${loginUrl}/cc/login.html?${loginMethod}&redirect_to=${encodeURIComponent(window.location.href)}`
            } else if (data.code === 400103) {
              Toast('跳转至注册页！url:' + error.config.url)
              window.location = '/partner-register'
            } else {
              Toast({
                type: 'fail',
                message: data.code === 500 ? '服务器异常，请稍后重试！\n' : data.message
              })
            }
            return Promise.reject(data)
          })
      }
    } else {
      $service[key] = service[key]
    }
  })
  return $service
}

function install (Vue) {
  Vue.mixin({
    beforeCreate () {
      const service = this.$options.service
      const loading = this.$options.loading
      const $parent = this.$parent
      if (service) {
        this.$service = createProxy(service, loading, this)
      } else if ($parent && $parent.$service) {
        this.$service = this.$parent.$service
      }
    }
  })
}

const ServicePlugin = { install }

export { ServicePlugin as default }
